import { render, staticRenderFns } from "./componentCc.vue?vue&type=template&id=1ac6c71a&"
import script from "./componentCc.vue?vue&type=script&lang=ts&"
export * from "./componentCc.vue?vue&type=script&lang=ts&"
import style0 from "./componentCc.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports